import { SvgIcon, SvgIconProps } from '@mui/material';

export function FamilyAndAncestryDashboardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g clip-path="url(#clip0_1966_45763)">
        <path
          d="M2.14961 12.1347C3.12576 13.1062 4.83572 12.9793 4.83572 12.9793C4.83572 12.9793 4.96327 11.2774 3.98712 10.3059C3.01097 9.33438 1.30101 9.46132 1.30101 9.46132C1.30101 9.46132 1.17346 11.1632 2.14961 12.1347Z"
          fill="#4A3B8F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1966_45763">
          <rect width="28.3279" height="32" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
